import { mergeTooltipActions } from '../../../../core/components/series-action/utils/mergeTooltipActions.js';
import { safeGet } from '../../../../core/utils/safe-get.js';
import { useDotSeriesData } from '../../../hooks/useDotSeriesData.js';
import { useXYChartTruncationMode } from '../../../hooks/useXYChartTruncationMode.js';
import type { DotSeriesWithDatapoints } from '../../../types/xy-chart-internals.js';
import type { DotDatapoint } from '../../../types/xy-chart.js';
import { XYChartTooltipHeader } from '../XYChartTooltipHeader/XYChartTooltipHeader.js';
export interface DotTooltipHeaderProps {
  datapoint: DotDatapoint;
  series: DotSeriesWithDatapoints;
}

export function DotSeriesTooltipHeader({
  datapoint,
  series,
}: DotTooltipHeaderProps) {
  const { seriesToMetadata } = useDotSeriesData();
  const { truncationMode } = useXYChartTruncationMode();

  const {
    actions: seriesActions,
    name,
    color,
  } = safeGet(seriesToMetadata, series);

  const actions = () => seriesActions?.({ ...datapoint, name });

  const content = {
    id: crypto.randomUUID(),
    name: name,
  };

  return (
    <XYChartTooltipHeader
      color={color.Default}
      name={name}
      actions={mergeTooltipActions(content, actions)}
      truncationMode={truncationMode}
    />
  );
}

DotSeriesTooltipHeader['displayName'] = 'DotSeriesTooltipHeader';
